import script from "./lg.vue?vue&type=script&setup=true&lang=js"
export * from "./lg.vue?vue&type=script&setup=true&lang=js"

import "./lg.vue?vue&type=style&index=0&id=444d699e&lang=scss"

const __exports__ = script;

export default __exports__